import type { MessageTemplate, MessageTemplateReportType } from '@gcv/shared';
import { injectable } from 'inversify';

import { banksApi } from './api-util/api';

export interface CreateMessageTemplatePayload {
  name: string;
  description?: string;
  report_type: MessageTemplateReportType;
}

export interface GetMessageTemplatesParams {
  /** Which versions to return, e.g. 'draft', 'latest', or 'draft,latest'. Omit for latest published only. */
  version?: string;
  /** When true, return only the most-recently-updated version of each logical template. */
  last_updated_only?: boolean;
}

@injectable()
export class MessageTemplatesApi {
  async getMessageTemplatesForBank(
    bankId: string,
    params?: GetMessageTemplatesParams
  ): Promise<MessageTemplate[]> {
    return await banksApi().get(
      `/banks/${bankId}/message-templates`,
      params as Record<string, unknown> | undefined
    );
  }

  async createMessageTemplate(bankId: string, data: CreateMessageTemplatePayload): Promise<MessageTemplate> {
    return await banksApi().post(`/banks/${bankId}/message-templates`, data);
  }
}
